<template lang="pug">
  main
    NavBarInventario
    Loader(v-show="isLoading")
    section.section(v-show="!isLoading")
      .container
        .columns.has-text-centered
          .column
            h1.is-size-3
              | Consumibles Detalle&nbsp
              a.button.is-dark.is-rounded(@click="backPage")
                i.fas.fa-times
        .columns
          CardConsumibleDetalle(:consumible="consumibleData")
        .columns.has-text-centered
          .column.is-2
            a.button.is-black.is-small.is-rounded(v-show="permisos.inventarios != 6" @click="addItems(consumibleSelected)")
              i.fas.fa-plus
              | &nbspAgregar Consumibles
          .column.is-2(v-show="permisos.inventarios != 6")
            a.button.is-danger.is-small.is-rounded(@click="deleteItems(consumibleSelected)" v-show="consumibleData.stock > 0")
              i.fas.fa-plus
              | &nbspDar Salida Consumibles
        .columns
          .column.is-12
            bulma-accordion
              bulma-accordion-item
                p.title.is-4.has-text-weight-normal(slot='title')
                  | En traslado&nbsp
                  span.tag.is-black {{ sumaInTras }}
                i.material-icons(slot='icon') more_vert
                .high(slot='content')
                  TbConsumiblesTras(:consumibles="itemsTras" v-show="itemsTras.length > 0" @firmarSalida="firmarSalida")
                  .notification(v-show="itemsTras.length === 0")
                    | No registros de Entradas.
        .columns
          .column.is-12
            bulma-accordion
              bulma-accordion-item
                p.title.is-4.has-text-weight-normal(slot='title')
                  | Entradas&nbsp
                  span.tag.is-black {{ sumaIn }}
                i.material-icons(slot='icon') more_vert
                .high(slot='content')
                  TbConsumiblesIn(:consumibles="itemsIn" v-show="hayItemsIn" @firmarSalida="firmarSalida")
                  .notification(v-show="!hayItemsIn")
                    | No registros de Entradas.
        .columns
          .column.is-12
            bulma-accordion
              bulma-accordion-item
                p.title.is-4.has-text-weight-normal(slot='title')
                  | Salidas &nbsp
                  span.tag.is-info 
                    i.fas.fa-paper-plane
                    | &nbsp{{ sumaTrasl }}
                  | &nbsp
                  span.tag.is-black 
                    i.fas.fa-file-signature
                    | &nbsp{{ sumaOut }}
                i.material-icons(slot='icon') more_vert
                .high(slot='content')
                  TbConsumiblesOut(:consumibles="itemsOut" v-show="hayItemsOut" @firmarSalida="firmarSalida")
                  .notification(v-show="!hayItemsOut")
                    | No registros de salidas.
        .columns
          .column.is-12
            bulma-accordion
              bulma-accordion-item
                p.title.is-4.has-text-weight-normal(slot='title')
                  | Asignaciones &nbsp
                  span.tag.is-black 
                    i.fas.fa-file-signature
                    | &nbsp{{ sumaAsign }}
                i.material-icons(slot='icon') more_vert
                .high(slot='content')
                  TbConsumiblesAsign(:consumibles="itemsAsign" v-show="itemsAsign.length > 0" @firmarAsignacion="firmarAsignacion")
                  .notification(v-show="!hayItemsOut")
                    | No registros de salidas.
        .columns.column-blanco
</template>

<script>
  import Loader from '@/components/shared/Loader.vue'
  import CardConsumibleDetalle from './CardConsumibleDetalle.vue'
  import NavBarInventario from './layout/NavBarInventario.vue'
  import TbConsumiblesTras from './TbConsumiblesTraslado.vue'
  import TbConsumiblesIn from './TbConsumiblesIn.vue'
  import TbConsumiblesOut from './TbConsumiblesOut.vue'
  import TbConsumiblesAsign from './TbConsumiblesAsign.vue'
  import { BulmaAccordion, BulmaAccordionItem } from 'vue-bulma-accordion'
  import { mapState } from 'vuex'
  import InventarioServices from '../../services/inventario/inventario'

  export default {
    name: 'ConsumibleDetalle',
    components: { Loader, NavBarInventario, CardConsumibleDetalle, BulmaAccordion, BulmaAccordionItem, TbConsumiblesIn, TbConsumiblesOut, TbConsumiblesTras, TbConsumiblesAsign },
    data() {
      return {
        isLoading: true,
        itemsIn: [],
        itemsOut: [],
        itemsTras: [],
        itemsAsign: [],
        isvisibleData: true,
        settings: {
          maxScrollbarLength: 60
        },
        hayItemsIn: false,
        hayItemsOut: false,
        sumaIn: 0,
        sumaTrasl: 0,
        sumaOut: 0,
        sumaInTras: 0,
        sumaAsign: 0,
        totalCons: 0,
        consumibleData: {},
        almacenes: [],
        origen: {},
      }
    },
    methods: {
      iniciarComponente() {
        this.obtenerAlmacenes()
      },
      getItemsTras() {
        InventarioServices.getConsumibles_Tras(this.consumibleSelected.id, this.origen.id_oficina)
          .then( res => {
            this.itemsTras = res.map(this.convetirConsTras)
            this.getItemsIn()
          })
          .catch((e) => {
            this.isLoading = false
            this.displayToast('bubble', `Error: ${e.message}`,'ban', 'OK')
          })
      },
      getItemsIn() {
        InventarioServices.getConsumibles_In(this.consumibleSelected.id, this.origen.id_oficina)
          .then( res => {
            this.itemsIn = res.map(this.convetirConsIn)
            if (this.itemsIn.length > 0 ){
              this.hayItemsIn = true
            } else {
              this.hayItemsIn = false
            }
            this.getItemsOut()
          })
          .catch((e) => {
            this.isLoading = false
            this.displayToast('bubble', `Error: ${e.message}`,'ban', 'OK')
          })
      },
      convetirConsTras(cons) {
        return {
          ...cons,
          cantidad_e: Number(cons.cantidad_e),
          cantidad_r: Number(cons.cantidad_r),
          cantidad_t: Number(cons.cantidad_t),
          origen: parseInt(cons.origen),
          destino: parseInt(cons.destino),
          estado: parseInt(cons.estado),
          id: parseInt(cons.id),
          id_salida: parseInt(cons.id_salida),
          idconsumible: parseInt(cons.idconsumible),
          isSalida: true,
        }
      },
      convetirConsIn(cons) {
        return {
          ...cons,
          cantidad: Number(cons.cantidad),
          estado: parseInt(cons.estado),
          id: parseInt(cons.id),
          id_proveedor: parseInt(cons.id_proveedor),
          id_salida: parseInt(cons.id_salida),
          idconsumible: parseInt(cons.idconsumible),
          precioUnitario: Number(cons.precioUnitario).toFixed(2),
          tipo: parseInt(cons.tipo),
          cajaChica: parseInt(cons.cajaChica),
          moneda: Number(cons.moneda),
        }
      },
      convetirConsOut (cons) {
        return {
          ...cons,
          cantidad_e: Number(cons.cantidad_e),
          cantidad_r: Number(cons.cantidad_r),
          cantidad_t: Number(cons.cantidad_t),
          origen: parseInt(cons.origen),
          destino: parseInt(cons.destino),
          estado: parseInt(cons.estado),
          id: parseInt(cons.id),
          id_salida: parseInt(cons.id_salida),
          idconsumible: parseInt(cons.idconsumible),
          isSalida: true,
        }
      },
      getItemsOut() {
        InventarioServices.getConsumibles_Out(this.consumibleSelected.id, this.origen.id_oficina)
          .then( res => {
            this.itemsOut = res.map(this.convetirConsOut)
            if (this.itemsOut.length > 0 ){
              this.hayItemsOut = true
            } else {
              this.hayItemsOut = false
              this.isLoading = false
            }
            this.getItemsAsign()
          })
          .catch((e) => {
            this.isLoading = false
            this.displayToast('bubble', `Error: ${e.message}`,'ban', 'OK')
          })
      },
      getItemsAsign() {
        InventarioServices.getConsumibles_Asign(this.consumibleSelected.id, this.origen.id_oficina)
          .then( res => {
            this.itemsAsign = res.map(this.convetirConsAsign)
            this.getSumas()
          })
          .catch((e) => {
            this.isLoading = false
            this.displayToast('bubble', `Error: ${e.message}`,'ban', 'OK')
          })
      },
      convetirConsAsign (cons) {
        return {
          ...cons,
          cantidad_e: Number(cons.cantidad_e),
          cantidad_r: Number(cons.cantidad_r),
          origen: parseInt(cons.origen),
          destino: parseInt(cons.destino),
          estado: parseInt(cons.estado),
          id: parseInt(cons.id),
          id_asignacion: parseInt(cons.id_asignacion),
          idconsumible: parseInt(cons.idconsumible),
          isSalida: false
        }
      },
      getSumas () {
        let totalIn = 0
        let totalOut = 0
        let totalTrasl = 0
        this.itemsIn.forEach(item => {
          totalIn = totalIn + item.cantidad
        })
        this.sumaIn = totalIn
        this.itemsOut.forEach(item => {
          if (item.origen === this.origen.id_oficina) {
            if (item.cantidad_r > 0) {
              // Si ya recibio algo
              totalOut = totalOut + item.cantidad_r
              totalTrasl = totalTrasl + 0
            } else {
              // Si aun no ha recibido
              if (item.cantidad_r == item.cantidad_e) {
                totalOut = totalOut + item.cantidad_r
                totalTrasl = totalTrasl + 0
              } else {
                totalOut = totalOut + item.cantidad_r
                totalTrasl = totalTrasl + item.cantidad_e
              }
            }
          }
        })
        this.sumaAsign = this.itemsAsign.reduce((acc, { cantidad_r }) => acc + cantidad_r, 0)
        this.sumaOut = totalOut
        this.sumaTrasl = totalTrasl
        this.totalCons = this.sumaIn - this.sumaTrasl - this.sumaOut - this.sumaAsign
        this.sumaInTras = this.itemsTras.reduce(( acc, { cantidad_t }) => acc + cantidad_t, 0)
        this.consumibleData = this.convetirObjeto(this.consumibleSelected)
        this.isLoading = false
      },
      convetirObjeto (data) {
        return {
          ...data,
              itemsIn: this.sumaIn,
              itemsOut: this.sumaOut,
              itemsTrals: this.sumaTrasl,
              stock: this.totalCons
        }
      },
      getTitle() {
        let texto = ''
        if (this.consumibleSelected.subcategoria === '') {
          texto = `<p>
          <b>Categoría:&nbsp</b>
          <small>${this.consumibleSelected.categoria}</small>
          </p>
          `
        } else {
          texto = `<p>
          <b>Categoría:&nbsp</b>
          <small>${this.consumibleSelected.categoria} - ${this.consumibleSelected.subcategoria}</small>
          </p>`
        }
        return texto
      },
      getContent () {
        let texto = `
        <div class="tags has-addons">
          <span class="tag">MARCA</span>
          <span class="tag is-black">${this.consumibleSelected.marca}</span>
        </div>
        <div class="tags has-addons">
          <span class="tag">MODELO</span>
          <span class="tag is-black">${this.consumibleSelected.modelo}</span>
        </div>
        <div class="tags has-addons">
          <span class="tag">CANTIDAD</span>
          <span class="tag is-black">${this.consumibleSelected.cantidad}</span>
        </div>
        <div class="tags has-addons">
          <span class="tag">LIMITE</span>
          <span class="tag is-black">${this.consumibleSelected.limite}</span>
        </div>
        `
        return texto
      },
      toggleData () {
        if (this.isvisibleData) {
          this.isvisibleData = false
        } else {
          this.isvisibleData = true
        }
      },
      scrollHanle(evt) {
      // console.log(evt)
      },
      
      addItems (cons) {
        let myObj = {
          cantidad: this.totalCons,
          categoria: cons.categoria,
          id_cat: cons.id_cat,
          id_subcat: cons.id_subcat,
          limite: cons.limite,
          id: cons.id,
          marca: cons.marca,
          modelo: cons.modelo,
          subcategoria: cons.subcategoria,
          text: cons.text

        }
        this.$store.commit('selectConsumible', myObj)
        this.$router.push('/Inventario/Consumibles/Agregar')
      },
      deleteItems (consumible) {
        this.$store.commit('selectConsumible', consumible)
        this.$router.push('/Inventario/Consumibles/Salidas')
      },
      firmarSalida(salida) {
        this.$store.commit('firmarSalidaConsumible', salida)
        this.$router.push('/Inventario/Consumibles/Firmar')
      },
      firmarAsignacion(asignacion) {
        this.$store.commit('firmarSalidaConsumible', asignacion)
        this.$router.push('/Inventario/Consumibles/Firmar')
      },
      backPage () {
        this.$router.back()
      },
      obtenerAlmacenes() {
        InventarioServices.getAlmacenesConsumibles('c')
          .then( data => {
            this.almacenes = data.map(this.convertirAlmacenes)
            this.obtenerAlmacenOrigen()
          })
          .catch((e) => {
            this.isLoading = false
            this.displayToast('bubble', `Error: ${e.message}`,'ban', 'OK')
          })
      },
      convertirAlmacenes (ofi) {
        return {
          ...ofi,
          id: parseInt(ofi.id),
          id_ubicacion: parseInt(ofi.id_ubicacion),
          id_oficina: parseInt(ofi.id_oficina),
          inventario: parseInt(ofi.inventario) == 1 ? true : false,
        }
      },
      obtenerAlmacenOrigen() {
        if (this.almacenSelect && this.almacenSelect !== 'c') {
          this.origen = this.almacenes.find( ofi => ofi.clave === this.almacenSelect)
        } else {
          this.almacenes.map( alm => {
            const encontrado = alm.almacenistas.find( a => a.id_usuario === this.userLogin.id)
            if (encontrado) {
              this.origen = alm
            }
          })
        }
        this.getItemsTras()
      },
      displayToast(tema,text, icon, actionText) {
        let toast = this.$toasted.show(text, { 
          theme: tema, 
          position: "bottom-right", 
          duration : 3000,
          iconPack: 'fontawesome',
          icon: icon,
          action : {
            text : actionText,
            onClick : (e, toastObject) => {
              toastObject.goAway(0)
            }
          },
        })
      },
    },
    created () {
      this.iniciarComponente()
    },
    computed: {
      ...mapState(['userLogin', 'consumibleSelected', 'permisos', 'almacenSelect'])
    }
  }
</script>

<style lang="css" scoped>
  .scroll-area {
    position: relative;
    margin: auto;
    height: 400px;
    border-radius: 5px 5px 5px 5px;
    border: 1px solid #00d1b2;
  }
  .ps__thumb-x, .ps__thumb-y {
    background-color: #00d1b2;
    width: 10px;
  }

  .column-blanco {
    padding-bottom: 100px;
  }
</style>


// WEBPACK FOOTER //
// src/components/inventario_Componentes/ConsumibleDetalle.vue